const $body = document.body;

const init = (instance) => {

};

export default class SearchHeader {
    constructor() {
        this.$el   = document.querySelector('.search-form');
        this.$form = document.querySelector('.search-form__form');

        this.isActive = this.$el.classList.contains('search-form--active');

        init(this);
    }

    show() {
        $body.classList.add('app--active-search');
        this.isActive = true;
    }

    hide() {
        $body.classList.remove('app--active-search');
        this.isActive = true;
    }

}
